"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardStep = exports.Wizard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _formik = require("formik");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-tabs */
/**
 * Wizard is a higher order component that contains the logic for which child page to display
 * Wizard expects each WizardStep to contain a prop for `onSubmit` and an optional `validationSchema`
 * When you are using this component you should create a piece of state in the parent component for `pageNumber`
 * with a corresponding function to update the state `setPageNumber`. In this way, we can have access to the `pageNumber`
 * in the parent component, while the wizard still takes care of updating the `pageNumber` as you navigate. This piece of state
 * and function to update state should be passed as props to the Wizard component
 *
 * Validation data can be provided in two ways, 1 way is to provide a yup validationSchema object to the WizardStep components that you create
 * In that case the validation will apply to that page/step only. The second way to provide validation is by providing a prop called valiationData to the wizard itself
 * This allows you to create a function in your Calculator instance that can update the validationData, check the LifeInsuranceWizardCalc for examples of how to do this.
 * This also allows developers full control over what is being validated at any point in time
 * IMPORTANT note - if you provide the validationData prop it will take priority over the validationArray that you are providing to the WizardStep.
 *
 *
 * @param {object} formik A formik instance is passed to the wizard, which we destructure
 * @returns The content from one WizardStep along with the applicable buttons (wrapped by Formik HOC)
 * @maxSteps Needed to determine which tealium event to send. The 'next' button will always move to the next page, but it can additioinaly perform API calls which calculates the results for users.
 * We want to send different tealium events when we are calculating results than when we are simply moving to the next data entry page. maxSteps is needed to make the determination
 * between these two scenarios.
 */
var Wizard = _ref => {
  var _currentConfig$NextBu, _currentConfig$NextBu2, _currentConfig$NextBu3, _currentConfig$NextBu4;
  var {
    children,
    initialValues,
    onSubmit,
    initialTouched,
    passthroughId,
    currentConfig,
    setStepNumber,
    stepNumber,
    errorData,
    validationData,
    isNotNatLang,
    calcName,
    maxSteps,
    centerNavButtons,
    disabledSubmit,
    disabledBack
  } = _ref;
  var steps = _react.default.Children.toArray(children);
  var [snapshot, setSnapshot] = (0, _react.useState)(initialValues);
  var step = steps[stepNumber];
  var totalSteps = steps.length;
  var isLastStep = stepNumber === totalSteps - 1;
  var iconRightSide = (currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu = currentConfig.NextButton) === null || _currentConfig$NextBu === void 0 ? void 0 : _currentConfig$NextBu.Icon) && (currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu2 = currentConfig.NextButton) === null || _currentConfig$NextBu2 === void 0 ? void 0 : _currentConfig$NextBu2.Side) != 'L';
  var iconLeftSide = (currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu3 = currentConfig.NextButton) === null || _currentConfig$NextBu3 === void 0 ? void 0 : _currentConfig$NextBu3.Icon) && (currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu4 = currentConfig.NextButton) === null || _currentConfig$NextBu4 === void 0 ? void 0 : _currentConfig$NextBu4.Side) == 'L';
  var hideBack = stepNumber == 0 || step.props.hideBack;
  var next = values => {
    if (stepNumber <= maxSteps - 3) {
      // simply moving to next, no result calcualtion done
      (0, _utils.customTealiumEvent)(calcName, 'click', 'next');
    } else if (stepNumber == maxSteps - 2) {
      // this would be the calculate page, in which we would want to send a different tealium event than the if statement above
      (0, _utils.customTealiumEvent)(calcName, 'field_input', 'calculate');
    }
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };
  var previous = values => {
    (0, _utils.customTealiumEvent)(calcName, 'click', 'back');
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (values, bag) {
      var error = false;
      // If onSubmit exists for the current step, then invoke the onSubmit
      // If an error happens, set error to true so we can avoid moving pages in error case
      if (step.props.onSubmit) {
        try {
          yield step.props.onSubmit(values, bag);
        } catch (e) {
          error = true;
        }
      }
      // If this is the last step, trigger the top level onSubmit of the form
      // else we want to reset the touched fields and navigate to the next page
      if (isLastStep) {
        return onSubmit(values, bag);
      } else if (!error) {
        bag.setTouched({});
        next(values);
      }
    });
    return function handleSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Simple function that will check if we are skipping validation at the page level, else will return normal formik test
  var isDisabled = isSubmittingOrInvalid => {
    if (step.props.nextButtonAsTypeButton) {
      return false;
    }
    return isSubmittingOrInvalid;
  };

  // Define additional classNames for buttons
  var backButtonClass = '';
  var nextButtonClass = '';
  var sideButtonClass = 'floatRight';
  if (isLastStep) {
    backButtonClass += 'customLeftPaddingTablet';
    nextButtonClass += 'displayBlockButton';
    sideButtonClass += ' displayBlockButton customLeftPaddingTablet';
  }
  var centerNav = centerNavButtons && centerNavButtons[stepNumber] ? 'text-align-center-tablet' : '';
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: snapshot,
    initialTouched: initialTouched,
    onSubmit: handleSubmit,
    validationSchema: validationData || step.props.validationSchema
  }, formik => {
    var _currentConfig$BackBu, _currentConfig$BackBu2, _currentConfig$BackBu3, _currentConfig$NextBu5, _currentConfig$NextBu6, _currentConfig$NextBu7, _currentConfig$NextBu8, _currentConfig$RightH, _currentConfig$RightH2, _currentConfig$RightH3, _currentConfig$RightH4;
    // This will force a validation to run everytime the 'step' state changes
    // This validation will force each new page to be in an invalid state, which will force the 'next' button to be disabled until the form is valid
    (0, _react.useEffect)(() => {
      // Providing a way to allow next/submit/refine to be enabled upon page load, by default the validation will run and will disable the next button.
      formik.validateForm();
    }, [step]);

    // Conditional logic that handles whether a calculator is in the natural language form or regular form
    // By default, assumption is that the natural language form is used.
    var conditionalProps = {};
    if (!isNotNatLang || !isNotNatLang[stepNumber]) {
      conditionalProps.className = 'mm-form-inline';
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("form", _extends({
      id: passthroughId,
      onSubmit: formik.handleSubmit
    }, conditionalProps), errorData && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Alert, {
      type: "danger"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Error: "), "Something went wrong. Please try again or come back later")), step, /*#__PURE__*/_react.default.createElement("p", {
      className: centerNav
    }, hideBack ? null : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      className: backButtonClass,
      onClick: () => previous(formik.values),
      type: "button",
      disabled: disabledBack,
      variant: (currentConfig === null || currentConfig === void 0 || (_currentConfig$BackBu = currentConfig.BackButton) === null || _currentConfig$BackBu === void 0 ? void 0 : _currentConfig$BackBu.Variant) || 'link'
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: currentConfig === null || currentConfig === void 0 || (_currentConfig$BackBu2 = currentConfig.BackButton) === null || _currentConfig$BackBu2 === void 0 ? void 0 : _currentConfig$BackBu2.Icon
    }), /*#__PURE__*/_react.default.createElement("span", null, (0, _htmlReactParser.default)(currentConfig === null || currentConfig === void 0 || (_currentConfig$BackBu3 = currentConfig.BackButton) === null || _currentConfig$BackBu3 === void 0 ? void 0 : _currentConfig$BackBu3.Label) || 'Back')), step.props.hideNext ? null : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      className: nextButtonClass,
      disabled: disabledSubmit || isDisabled(formik.isSubmitting || !formik.isValid),
      type: step.props.nextButtonAsTypeButton ? 'button' : 'submit',
      variant: (currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu5 = currentConfig.NextButton) === null || _currentConfig$NextBu5 === void 0 ? void 0 : _currentConfig$NextBu5.Variant) || 'primary',
      onClick: step.props.nextButtonAsTypeButton ? () => step.props.onSubmit(formik.values) : () => {}
    }, iconLeftSide && /*#__PURE__*/_react.default.createElement("span", {
      className: currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu6 = currentConfig.NextButton) === null || _currentConfig$NextBu6 === void 0 ? void 0 : _currentConfig$NextBu6.Icon
    }), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu7 = currentConfig.NextButton) === null || _currentConfig$NextBu7 === void 0 ? void 0 : _currentConfig$NextBu7.Label) || 'Next')), iconRightSide && /*#__PURE__*/_react.default.createElement("span", {
      className: currentConfig === null || currentConfig === void 0 || (_currentConfig$NextBu8 = currentConfig.NextButton) === null || _currentConfig$NextBu8 === void 0 ? void 0 : _currentConfig$NextBu8.Icon
    })), (currentConfig === null || currentConfig === void 0 || (_currentConfig$RightH = currentConfig.RightHandButton) === null || _currentConfig$RightH === void 0 ? void 0 : _currentConfig$RightH.Label) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "link",
      href: currentConfig === null || currentConfig === void 0 || (_currentConfig$RightH2 = currentConfig.RightHandButton) === null || _currentConfig$RightH2 === void 0 ? void 0 : _currentConfig$RightH2.Href,
      target: currentConfig === null || currentConfig === void 0 || (_currentConfig$RightH3 = currentConfig.RightHandButton) === null || _currentConfig$RightH3 === void 0 ? void 0 : _currentConfig$RightH3.Target,
      onClick: step.props.sideButtonOnClick,
      className: sideButtonClass
    }, (0, _htmlReactParser.default)(currentConfig === null || currentConfig === void 0 || (_currentConfig$RightH4 = currentConfig.RightHandButton) === null || _currentConfig$RightH4 === void 0 ? void 0 : _currentConfig$RightH4.Label)))));
  });
};

/**
 * Simple functional component that returns it's children only.
 *
 * @param {object} props Props are passed, we destructure the `children` only
 * @returns it's own children
 */
exports.Wizard = Wizard;
var WizardStep = _ref3 => {
  var {
    children
  } = _ref3;
  return children;
};
exports.WizardStep = WizardStep;